import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";

import { Action, Selector, StateContext, State, Store } from "@ngxs/store";
import { patch } from "@ngxs/store/operators";
import { tap, finalize } from "rxjs";

import { LocationService } from "src/app/shared/services/location/location.service";
import { LocationsEvents } from "./locations_events.actions";
import { OrganizationState } from "../organization/organization.state";

export class LocationsEventsStateModel {
	filter: any;
	location_events: any;
	loading: boolean;
}

@State<LocationsEventsStateModel>({
	name: "locationseventsstate",
	defaults: {
		filter: {
			page: "",
			per_page: "",
			q: "",
			total: "",
			s: [],
		},
		location_events: [],
		loading: false,
	},
})
@Injectable()
export class LocationsEventsState {
	constructor(private locationService: LocationService, private store: Store) {}

	@Selector()
	static currentPage(state: LocationsEventsStateModel): number {
		return state.filter.page;
	}

	@Selector()
	static itemsOnPage(state: LocationsEventsStateModel): number {
		return state.filter.per_page;
	}

	@Selector()
	static query(state: LocationsEventsStateModel): string {
		return state.filter.q;
	}

	@Selector()
	static total(state: LocationsEventsStateModel): string {
		return state.filter.total;
	}

	@Selector()
	static filter(state: LocationsEventsStateModel): string {
		return state.filter;
	}

	@Selector()
	static selectLocationEvents(state: LocationsEventsStateModel) {
		return state.location_events;
	}

	@Selector()
	static loading(state: LocationsEventsStateModel): boolean {
		return state.loading;
	}

	@Action(LocationsEvents.SetFilter)
	setFilter(ctx: StateContext<LocationsEventsStateModel>, action: LocationsEvents.SetFilter) {
		return ctx.setState(
			patch<LocationsEventsStateModel>({
				filter: action.filter,
			})
		);
	}

	@Action(LocationsEvents.FetchAll)
	getLocations(ctx: StateContext<LocationsEventsStateModel>) {
		const state = ctx.getState();
		let filter: any = state?.filter ? { ...state.filter } : {};

		delete filter.total;

		filter = {
			...filter,
			s: filter.s ? filter.s.join(",") : [],
		};

		const options = {
			params: new HttpParams({
				fromObject: filter,
			}),
		};

		const orga = this.store.selectSnapshot(OrganizationState.getOrganization);
		console.log("orga", orga);

		ctx.patchState({ loading: true });

		return this.locationService.fetchLocationsEvents(options).pipe(
			tap((returnData: any) => {
				console.log("returnData events", returnData);

				const state = ctx.getState();
				ctx.patchState({
					...state,
					location_events: returnData.data,
					filter: {
						...state.filter,
						page: returnData.current_page,
						per_page: returnData.per_page,
						total: returnData.total,
					},
				});
			}),
			finalize(() => {
				ctx.patchState({
					loading: false,
				});
			})
		);
	}
}
